import { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Overview from "@/components/landing/Overview";
import Residences from "@/components/landing/Residences";
import Amenities from "@/components/landing/Amenities";
import LocationSection from "@/components/landing/LocationSection";
import Faq from "@/components/landing/Faq";
import RentalSection from "@/components/landing/RentalSection";
import ServicesSection from "@/components/landing/ServicesSection";
import EnquirySection from "@/components/landing/EnquirySection";
import Footer from "@/components/landing/Footer";
import StickyCTA from "@/components/landing/StickyCTA";

const STATS = [
  { value: "600 Acres", label: "Integrated Township" },
  { value: "9-Hole", label: "Golf Course" },
  { value: "7-Acre", label: "Shantigram Lake" },
  { value: "2–6 Beds", label: "Homes & Villas" },
];

export default function LandingPage() {
  const [configuration, setConfiguration] = useState("");
  const [project, setProject] = useState("");

  const enquire = (projectName = "") => {
    if (projectName) setProject(projectName);
    document.getElementById("enquire")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main className="bg-cream font-sans text-slate-800 antialiased">
      <Navbar />
      <Hero onEnquire={() => enquire()} />
      <div data-testid="stats-strip" className="border-b border-black/5 bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-2 divide-x divide-black/5 px-6 md:grid-cols-4 lg:px-12">
          {STATS.map((s) => (
            <div key={s.label} className="px-4 py-8 text-center md:py-10">
              <p className="font-serif text-xl text-forest sm:text-2xl">{s.value}</p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-slate-400">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
      <Overview />
      <ServicesSection />
      <Residences onEnquire={enquire} />
      <Amenities />
      <LocationSection />
      <Faq />
      <RentalSection onEnquire={enquire} />
      <EnquirySection
        configuration={configuration}
        onConfigurationChange={setConfiguration}
        project={project}
        onProjectClear={() => setProject("")}
      />
      <Footer onEnquire={() => enquire()} />
      <StickyCTA onEnquire={() => enquire()} />
    </main>
  );
}
